// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultLanguage: 'en',
  apiUrl: 'beta.cpcardio.com/api/v2',
  apiVer2URL: 'beta.cpcardio.com/api/v2',
  // apiUrl: 'api.myki.cpcardio.com',
  bookingAPI: 'beta.cpcardio.com/myki-cardio-calendar-backend',
  imageDir: 'https://beta.cpcardio.com/api/',
  protocol: 'https://',
  deviceApiUrl: 'http://borov.net:8080/',
  socketIO: 'https://beta.cpcardio.com:8005',
  videoCallApi: 'https://beta.cpcardio.com/ws',
  videoCallWs: 'wss://beta.cpcardio.com/ws/',
  paypal: {
    clientId: 'AQi-l5BmFq8Z51egjPdiU4WLqI_zecVjSX9X1GXmy5jX9LWY1prlfGq4fXunq4lhavXedWno4umSFaoI'
  },
  revolut: {
    api_key: 'sk_o2sBAdK1H7wYlcRtevi55SNRMBCLYMBUgCqGDDnNSiBRD4xHtFnDOo6oAwtwvLHb',
    environment: 'sandbox',
    currency: 'USD'
  },
  useNewPeerService: true,
  version: '1.96'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
